<template>
  <div class="card">
    <div class="card-header text-center py-2">{{ titulo }}</div>
    <div class="card-body" v-if="verForm">
      <form @submit.prevent="guardar">
        
        <div class="row form-group mb-1">
          <label for="inputCodigo" class="col-sm-2 col-form-label">Código de empleado:</label>
          <div class="col-sm-4">
            <input
              type="text"
              v-model="form.codigo"
              class="form-control form-control-sm"
              :required="true"
              id="inputCodigo"
            >
          </div>

          <label for="inputNombre" class="col-sm-2 col-form-label">Nombre de empleado:</label>
          <div class="col-sm-4">
            <input
              type="text"
              v-model="form.nombre"
              class="form-control form-control-sm"
              :required="true"
              id="inputNombre"
            >
          </div>
        </div>

        <div class="row form-group mb-1">
          <label for="inputNit" class="col-sm-2 col-form-label">NIT:</label>
          <div class="col-sm-4">
            <input
              type="text"
              v-model="form.nit"
              class="form-control form-control-sm"
              :required="true"
              id="inputNit"
            >
          </div>

          <label for="inputDPI" class="col-sm-2 col-form-label">DPI:</label>
          <div class="col-sm-4">
            <input
              type="text"
              v-model="form.dpi"
              class="form-control form-control-sm"
              :required="true"
              id="inputDPI"
            >
          </div>
        </div>

        <div class="row form-group mb-1">
          <label for="inputDireccion" class="col-sm-2 col-form-label">Dirección:</label>
          <div class="col-sm-4">
            <input
              type="text"
              v-model="form.direccion"
              class="form-control form-control-sm"
              id="inputDireccion"
            >
          </div>

          <label for="inputCorreo" class="col-sm-2 col-form-label">Correo:</label>
          <div class="col-sm-4">
            <input
              type="email"
              v-model="form.correo"
              class="form-control form-control-sm"
              id="inputCorreo"
            >
          </div>
        </div>

        <div class="row form-group mb-1">
          <label for="inputMonto" class="col-sm-2 col-form-label">Monto máximo:</label>
          <div class="col-sm-4">
            <input
              type="number"
              step="0.01"
              v-model="form.monto_maximo"
              class="form-control form-control-sm"
              placeholder="Monto para realizar compras"
              :required="true"
              id="inputMonto"
            >
          </div>
          <label for="inputUsuario" class="col-sm-2 col-form-label">Usuario:</label>
          <div class="col-sm-4">
            <input
              type="text"
              v-model="form.usuario"
              class="form-control form-control-sm"
              :required="true"
              id="inputUsuario"
            >
          </div>
        </div>

        
        <div class="form-group row mb-1">
          <label for="inputClave" class="col-sm-2 col-form-label" v-if="reg == ''">Clave:</label>
          <div class="col-sm-4" v-if="reg == ''">
            <input
              type="password"
              v-model="form.clave"
              class="form-control form-control-sm"
              :required="true"
              id="inputClave"
            >
          </div>
          <div v-else class="offset-sm-2 col-sm-4">
            <div class="form-check">
              <input type="checkbox" class="form-check-input" v-model="form.activo" :true-value="1" :false-value="0" id="activo">
              <label class="form-check-label" for="activo"> Activo</label>
            </div>
          </div>

          <div class="col-sm-6 text-right">
            <button
              type="button"
              class="btn btn-sm btn-secondary mr-1 mt-3"
              v-if="reg !== ''"
              @click.prevent="limpiar"
            >
              Nuevo
            </button>
            <button type="submit" class="btn btn-sm btn-primary mt-3" :disabled="btnGuardar">
              <span
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
                v-if="btnGuardar"
              ></span>
              <span class="sr-only" v-if="btnGuardar">
                {{ reg === '' ? 'Guardando...':'Actualizando...' }}
              </span>
              <span v-if="!btnGuardar">
                {{ reg === '' ? 'Guardar':'Actualizar' }}
              </span>
            </button>
          </div>
        </div>
      </form>
    </div>
    <div class="card-footer text-muted p-1">
      <span v-if="inicio">Buscando...</span>
      <div class="input-group input-group-sm mb-0" v-else>
        <input 
          type="text" 
          class="form-control" 
          v-model="listaTermino"
          placeholder="Buscar por codigo o nombre de empleado" 
          aria-label="Buscar por codigo o nombre de empleado" 
          aria-describedby="btnBuscarNombre"
        >
        <div class="input-group-append">
          <button 
            class="btn btn-outline-secondary px-3" 
            type="button" 
            @click="verForm = !verForm"
            id="btnBuscarNombre"
          >
            <font-awesome-icon icon="angle-up" v-if="verForm"/>
            <font-awesome-icon icon="angle-down" v-else/>
          </button>
        </div>
      </div>
    </div>
    <div class="table-responsive" v-if="!inicio">
      <table class="table table-sm">
        <thead class="thead-light">
          <tr>
            <th scope="col">#</th>
            <th scope="col">Código</th>
            <th scope="col">Nombre</th>
            <th scope="col">Usuario</th>
            <th scope="col">NIT</th>
            <th scope="col">DPI</th>
            <th scope="col" class="text-right">Saldo máximo</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(i, idx) in filtrada" :key="i.id">
            <th scope="row">{{ idx + 1 }}</th>
            <td><a href="#" @click.prevent="editar(idx)">{{ i.codigo }}</a></td>
            <td>{{ i.nombre }}</td>
            <td>{{ i.usuario }}</td>
            <td>{{ i.nit }}</td>
            <td>{{ i.dpi }}</td>
            <td class="text-right">Q. {{ parseFloat(i.monto_maximo).toFixed(2) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import ManteAccion from '../mixins/ManteAccion.js';

export default {
  name: 'ManteBazarUsuario',
  mixins: [ManteAccion],
  data: () => ({
    titulo: 'Bazar usuarios'
  }),
  created () {
    this.nombre = 'usuario';
    this.listaFiltrar = 'nombre';
  },
  methods: {
    buscar () {
      axios
      .get(this.UrlBase+'/usuario/buscar')
      .then(res => {
        this.lista = res.data.lista;
        this.inicio = false;
      })
      .catch(e => {
        this.inicio = false;
        alert(e);
      });
    },
    guardar () {
      this.btnGuardar = true;
      axios
      .post(this.UrlBase+'/usuario/guardar/'+this.reg, this.form)
      .then(r => {
        if (r.data.exito) {
          this.showSuccessMsg({message: r.data.mensaje});
          if (this.reg == '') {
            this.limpiar();
          }

          if (r.data.linea) {
            this.lista.push(r.data.linea);
          }
        } else {
          this.showWarnMsg({message: r.data.mensaje});
        }
        this.btnGuardar = false;
      })
      .catch(e => {
        this.showErrorMsg({message: e});
        this.btnGuardar = false;
      });
    },
  },
  computed: {
    filtrada () {
      if (this.listaTermino === null) {
        return this.lista;
      } else {
        return this.lista.filter(obj => {
          let cod = obj.codigo && obj.codigo.toLowerCase().includes(this.listaTermino.toLowerCase());
          let nom = obj.nombre && obj.nombre.toLowerCase().includes(this.listaTermino.toLowerCase());

          return (cod || nom);
        });
      }
    }
  }
}
</script>